import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { DescriptionComponent } from './description/description.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { RensComplementairesDiversComponent } from './rensComplementairesDivers/rens-complementaires-divers.component';
import { ChampLibreGroupComponent } from './champLibreGroup/champ-libre-group.component';
import { TypeLotsDiversComponent } from './typeLotsDivers/type-lots-divers.component';
import { TypeOuiNonComponent } from './typeOuiNon/type-oui-non.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeDelaisDiversComponent } from './typeDelaisDivers/type-delais-divers.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormDiversInitialComponent } from './formDiversInitial/formDiversInitial.component';
import { TypeNatureMarcheDiversComponent } from './typeDescNatureMarcheDivers/type-nature-marche-divers.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { Step5Component } from './steps/step5/step5.component';
import { FormDiversCommonModule } from '../common/formdivers.module';
import { LotComponent } from './lot/lot.component';
import { Step6Component } from './steps/step6/step6.component';

@NgModule({
  declarations: [

    TypeCPVClassComponent,
    TypeLieuComponent,
    DescriptionComponent,
    TypeObjCPVComponent,
    TypeVoieComponent,
    RensComplementairesDiversComponent,
    ChampLibreGroupComponent,
    TypeLotsDiversComponent,
    LotComponent,
    TypeOuiNonComponent,
    TypeTravauxComponent,
    TypeDelaisDiversComponent,
    TypeFournituresComponent,
    FormDiversInitialComponent,
    TypeNatureMarcheDiversComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step6Component
  ],
  exports: [
    FormDiversInitialComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    FormDiversCommonModule
  ]
})
export class FormDiversInitialModule {
}

